import React from 'react';
import moment from 'moment';
import DropdownDots from '../../components/DropdownDots';
import ReactTooltip from 'react-tooltip'
const actions = [
  {
    name: 'Cambiar estado',
    icon: 'ion-loop c-cyan',
    open: 'Estado',
    permiso:'ind_cambiar_estado',
  },
  {
    name: 'Crear solicitud excep.',
    icon: 'ion-clipboard c-cyan',
    open: 'SolExcep',
    permiso:'ind_crear_solicitud_excep',
  },
  {
    name: 'Notificar LAFIT',
    icon: 'ion-eye c-cyan',
    open: 'Lafit',
    permiso:'ind_notificar_lafit',
  },

  // {
  //   name: 'Cambiar Cliente',
  //   icon: 'ion-person c-cyan',
  //   open: 'cambiarCliente',
  // },
];

const CardStatus = props => (
  <li className='carCard-status-item col-md-2'>
    <div className='carCard-mainInfo-chasis'>
      <p className='labelInfo'>{props.title}</p>
      <p>{props.description}</p>
    </div>
  </li>
);

const Dato = props => (
  <div className='col-sm-2'>
    <p className='labelInfo'>{props.title}</p>
    <p>{props.description}</p>
  </div>
);

const tagFormatter = (cell) => {
  switch (cell) {
    case 'CREACION':
      return <p className='tag tag-Top tag-yellow'>{cell}</p>;
    case 'VIGENCIA':
      return <p className='tag tag-Top tag-green'>{cell}</p>;
    case 'ANULADA':
      return <p className='tag tag-Top tag-red'>{cell}</p>;
    default:
      return <p className='tag tag-Top'>{cell}</p>;
  }
};



const Detalle = props => (
  <div className='carCard'>
    <div className='carCard-firstInfo'>
      <div className='wrapper'>
        <div className='fdv-tagCotainer'>
          { tagFormatter(props.fdv.desEstadoFichaVta) }
        </div>
        <div className='fdv-validateList'>
          <p className='labelInfo'>Validado por:</p>
          <ul>
            { props.autorizaciones
                .map((autorizacion) => {
                  if (autorizacion.codAprobFichaVtaAut === 'A') {
                    return (
                      <li data-tip data-for={'tooltip-aprobado'+autorizacion.codAutFichaVta} key={autorizacion.codAutFichaVta}>
                        <ReactTooltip id={'tooltip-aprobado'+autorizacion.codAutFichaVta} >Aprobado por {autorizacion.nomAut} - {moment(autorizacion.fecUsuarioAut).format('DD/MM/YYYY HH:mm')}</ReactTooltip>
                        <i className='ion-checkmark-circled c-green' />
                        {autorizacion.desAutFichaVta}
                      </li>
                    );
                  }
                  return (
                    <li data-tip data-for='tooltip-aprobador' className='c-gray'
                      onMouseOver ={() =>
                        props.fnSeleccionAutorizador(
                          autorizacion.codAutFichaVta
                        )
                      }
                      key={autorizacion.codAutFichaVta}>
                      <ReactTooltip id='tooltip-aprobador' >Aprobadores
                      {props.autorizadoSeleccionado.map((aprobador, id) =>
                          <div key={id}>{aprobador.nomUsuaAuto}</div>
                      )}</ReactTooltip>
                      <i className='ion-minus-circled' />
                      {autorizacion.desAutFichaVta}
                    </li>
                  );
                }
              )
            }
          </ul>
        </div>
        <div className='text-right'>
          <DropdownDots actions={actions} openModal={props.openModal} descargaFichaVenta = {props.descargaFichaVenta} handlePermissions={props.handlePermissions}/>
        </div>
        <ul className='carCard-mainInfo row'>
          <li className='carCard-status-item col-md-8'>
            <div className='carCard-mainInfo-head'>
              <h2 className='carCard-title'>
                <div className='bold mt--3'>{props.fdv.nomPerso}</div>
              </h2>
              <h4 className='carCard-subTitle'>
                {props.fdv.codClie ? `COD ${props.fdv.codClie} ` : ''}
                &nbsp;
                {props.fdv.numRuc ? `RUC ${props.fdv.numRuc} ` : ''}
                &nbsp;
                {props.fdv.numDocuIden ? `DNI ${props.fdv.numDocuIden}` : ''}
              </h4>
            </div>
          </li>
          <CardStatus title='Nº FDV' description={props.fdv.numFichaVtaVeh} />
          <CardStatus title='Creado' description={moment(props.fdv.fecFichaVtaVeh).format('DD/MM/YYYY HH:mm')} />
        </ul>
      </div>
    </div>
    <div className='carCard-sec'>
      <div className='wrapper'>
        <div className='row'>
          <Dato title='Compañia' description={props.fdv.nombre} />
          <Dato title='Área de venta' description={props.fdv.desAreaVta} />
          <Dato title='Filial' description={props.fdv.nomFilial} />
          <Dato title='Vendedor' description={props.fdv.descripcion} />
          {/* <Dato title='Tipo de FDV' description={props.fdv.desTipoFichaVtaVeh} />
          <Dato title='Tipo de pago' description={props.fdv.desTipoPago} /> */}
        </div>
      </div>
    </div>
  </div>
);

export default Detalle;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/Detalle.js